import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Description as FormsIcon,
  Campaign as CampaignIcon,
} from '@mui/icons-material';
import { PageShell } from '../../components';
import PsychosocialFormsPage from './PsychosocialFormsPage';
import PsychosocialCampaignsPage from './PsychosocialCampaignsPage';

const PsychosocialDashboardPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <PageShell
      breadcrumbs={[{ label: 'Psicossocial', path: '/psychosocial' }]}
      title="Avaliação de Riscos Psicossociais"
      subtitle="Gerencie formulários COPSOQ e campanhas de avaliação psicossocial em conformidade com a NR-1."
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tab} onChange={(_e, v) => setTab(v)}>
          <Tab icon={<CampaignIcon />} iconPosition="start" label="Campanhas" />
          <Tab icon={<FormsIcon />} iconPosition="start" label="Formulários" />
        </Tabs>
      </Box>

      {tab === 0 && <PsychosocialCampaignsPage embedded />}
      {tab === 1 && <PsychosocialFormsPage embedded />}
    </PageShell>
  );
};

export default PsychosocialDashboardPage;
